import axios from 'axios';
import React, { useContext, useState } from 'react'
import { useParams } from 'react-router-dom';
import { BaseUrlContext } from '../Context/BaseUrl';
import { useEffect } from 'react';

import Swal from 'sweetalert2';
export default function RegistraionForm() {

    // GET ALL COURSES
    let [courses, setCourses] = useState([]);
    async function getAllCourses() {

        await axios.post(`${baseUrl}/get_courses`)
            .then(response => {
                // Handle the response
                if (response.data.Ecode === 200) {
                    console.log(response.data.Edata);
                    setCourses(response.data.Edata);
                }

            })
            .catch(error => {

                // Handle any errors
                console.error(error);
            });

    }
    useEffect(() => {
        getAllCourses();
    }, [])
    let { course_id, course_name } = useParams();

    const selectedCourse = courses.find(
        (course) => course.id === Number(course_id)
    );

    const amount = Number(selectedCourse?.fees || 0);

    const { baseUrl, imgUrl } = useContext(BaseUrlContext);
    const [firstName, setFirstName] = useState("");
    const [secondName, setSecondName] = useState("");
    const [lastName, setLastName] = useState("");
    const [position, setPosition] = useState("");
    const [email, setEmail] = useState("");
    const [mobile, setMobile] = useState("");


    // let [selectedCourse, setSelectedCourse] = useState();
    let [payment, setPayment] = useState('');
    let [selectedSession, setSelectedSession] = useState(0);
    let [onlinePayment, setOnlinePayment] = useState(0);
    let [responseData, setResponseData] = useState({});
    const handleCheckboxChange = (e) => {
        const value = e.target.checked ? 1 : 0;
        setOnlinePayment(value);
    };










    // validation

    const [errors, setErrors] = useState({});

    const validateForm = () => {
        let newErrors = {};

        if (!firstName.trim()) newErrors.firstName = "First name is required";
        if (!secondName.trim()) newErrors.secondName = "Second name is required";
        if (!lastName.trim()) newErrors.lastName = "Last name is required";
        if (!position.trim()) newErrors.position = "Position is required";

        if (!email.trim()) {
            newErrors.email = "Email is required";
        } else if (!/^\S+@\S+\.\S+$/.test(email)) {
            newErrors.email = "Enter a valid email";
        }

        if (!mobile.trim()) {
            newErrors.mobile = "Mobile number is required";
        } else if (!/^[0-9]{10,15}$/.test(mobile)) {
            newErrors.mobile = "Enter a valid mobile number";
        }

        if (!onlinePayment && onlinePayment !== 0 && onlinePayment !== 1) {
            newErrors.onlinePayment = "Please select online payment option";
        }

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };


    // async function registartionForCourses(e) {
    //     e.preventDefault();

    //     const bodyFormData = new FormData();
    //     bodyFormData.append('mobile', mobile);
    //     bodyFormData.append('email', email);
    //     bodyFormData.append('first_name', firstName);
    //     bodyFormData.append('second_name', secondName);
    //     bodyFormData.append('last_name', lastName);
    //     bodyFormData.append('course_id', course_id);
    //     bodyFormData.append('selected_session', selectedSession);
    //     bodyFormData.append('online_payment', onlinePayment);

    //     await axios.post(`${baseUrl}/payment`, bodyFormData)
    //         .then(response => {
    //             // Handle the response
    //             if (response.data.Ecode === 200) {
    //                 console.log(response.data.Edata);
    //                 setPayment(response.data.EHtml);
    //                 setResponseData(response.data.Edata)
    //                 // const scriptElement = document.createElement('script');
    //                 // scriptElement.innerHTML = response.data.EHtml;
    //                 const script = document.createElement('script');
    //                 script.innerText = response.data.EHtml;
    //                 document.body.appendChild(script);
    //                 // const paymentDiv = document.getElementById('payment');
    //                 // paymentDiv.innerHTML = response.data.EHtml;


    //                 // window.Checkout.showLightbox(); // Modify this according to the script's requirements
    //                 // document.getElementById('payment').innerHTML = response.data.EHtml;
    //             } else {
    //                 setPayment(response.data.Emsg)
    //             }

    //         })
    //         .catch(error => {

    //             // Handle any errors
    //             console.error(error);

    //         });

    // }
    function waitForCheckout(callback) {
        if (window.Checkout) {
            callback();
        } else {
            setTimeout(() => waitForCheckout(callback), 100);
        }
    }
    // async function registartionForCourses(e) {
    //     e.preventDefault();

    //     if (!validateForm()) {
    //         return; // ⛔ Stop if validation fails
    //     }

    //     const bodyFormData = new FormData();
    //     bodyFormData.append('mobile', mobile);
    //     bodyFormData.append('email', email);
    //     bodyFormData.append('first_name', firstName);
    //     bodyFormData.append('second_name', secondName);
    //     bodyFormData.append('last_name', lastName);
    //     bodyFormData.append('course_id', course_id);
    //     bodyFormData.append('selected_session', selectedSession);
    //     bodyFormData.append('online_payment', onlinePayment);

    //     try {
    //         const response = await axios.post(`${baseUrl}/payment`, bodyFormData);

    //         if (response.data.Ecode === 200) {
    //             setResponseData(response.data.Edata);
    //             setPayment(response.data.EHtml);

    //             const scriptTag = document.createElement("script");
    //             scriptTag.type = "text/javascript";
    //             scriptTag.text = response.data.EHtml;
    //             document.body.appendChild(scriptTag);

    //             waitForCheckout(() => {
    //                 window.Checkout.showLightbox();
    //             });
    //         } else {
    //             setPayment(response.data.Emsg);
    //         }
    //     } catch (error) {
    //         console.error(error);
    //     }
    // }
    async function registartionForCourses(e) {
        e.preventDefault();

        if (!validateForm()) return;

        const selectedCourse = courses.find(
            (course) => course.id === Number(course_id)
        );

        const amount = Number(selectedCourse?.fees || 0);

        const isForcedPayment = amount < 2000;
        const isOnline = isForcedPayment || onlinePayment === 1;

        const bodyFormData = new FormData();
        bodyFormData.append('mobile', mobile);
        bodyFormData.append('email', email);
        bodyFormData.append('first_name', firstName);
        bodyFormData.append('second_name', secondName);
        bodyFormData.append('last_name', lastName);
        bodyFormData.append('position', position);
        bodyFormData.append('course_id', course_id);
        bodyFormData.append('selected_session', selectedSession);

        bodyFormData.append('online_payment', isOnline ? 1 : 0);

        try {
            const response = await axios.post(`${baseUrl}/payment`, bodyFormData);

            if (response.data.Ecode === 200) {
                setResponseData(response.data.Edata);

                if (isOnline) {
                    setPayment(response.data.EHtml);

                    document
                        .querySelectorAll("script[data-checkout]")
                        .forEach(el => el.remove());

                    const scriptTag = document.createElement("script");
                    scriptTag.type = "text/javascript";
                    scriptTag.text = response.data.EHtml;
                    scriptTag.setAttribute("data-checkout", "true");

                    document.body.appendChild(scriptTag);

                    waitForCheckout(() => {
                        window.Checkout.showLightbox();
                    });

                } else {
                    setPayment("Reservation completed successfully");
                }

            } else {
                setPayment(response.data.Emsg);
            }

        } catch (error) {
            console.error(error);
        }
    }

    useEffect(() => {
        if (amount < 2000 && amount !== 0) {
            setOnlinePayment(1);
        }
    }, [amount]);
    // async function registartionForCourses(e) {
    //     e.preventDefault();

    //     const bodyFormData = new FormData();
    //     bodyFormData.append('mobile', mobile);
    //     bodyFormData.append('email', email);
    //     bodyFormData.append('first_name', firstName);
    //     bodyFormData.append('second_name', secondName);
    //     bodyFormData.append('last_name', lastName);
    //     bodyFormData.append('course_id', course_id);
    //     bodyFormData.append('selected_session', selectedSession);
    //     bodyFormData.append('online_payment', onlinePayment);

    //     try {
    //         const response = await axios.post(`${baseUrl}/payment`, bodyFormData);

    //         if (response.data.Ecode === 200) {
    //             console.log(response.data.Edata);
    //             setResponseData(response.data.Edata);


    //             setPayment(response.data.EHtml);


    //             const scriptTag = document.createElement("script");
    //             scriptTag.type = "text/javascript";
    //             scriptTag.text = response.data.EHtml;
    //             document.body.appendChild(scriptTag);

    //             waitForCheckout(() => {
    //                 window.Checkout.showLightbox();
    //             });


    //         } else {
    //             setPayment(response.data.Emsg);
    //         }
    //     } catch (error) {
    //         console.error(error);
    //     }
    // }

    // let BASEURL = 'https://my-health.sghcairo.net/patient_portal_testing';

    async function handleSubmit(data) {
        // e.preventDefault();
        // const bodyFormData = new FormData();
        // bodyFormData.append('mobile', responseData.request.mobile);
        // bodyFormData.append('full_name', responseData.trainee_name);
        // bodyFormData.append('amount', responseData.amount);
        // bodyFormData.append('course_id', responseData.course_id);
        try {
            const response = await axios.post(baseUrl + '/payment/state', {
                phone: responseData.request.mobile,
                full_name: responseData.trainee_name,
                course_id: responseData.course_id,
                email: responseData.request.email,
                amount: responseData.amount,
                data: data, // Assuming 'data' is already defined in your component
            });

            const msg = response.data.result;
            console.log('reaponse' + response.data);

            // if (data !== 0) {
            if (msg === 'SUCCESS') {

                console.log('reeeeeeesss' + data);
                Swal.fire({
                    position: 'top-end',
                    icon: 'success',
                    title: 'Thanks Mr. ' + responseData.trainee_name,
                    text: 'An email has been sent to your provided email address for confirmation.',
                    showConfirmButton: false,
                    timer: 9500
                });
            } else {
                Swal.fire({
                    icon: 'error',
                    title: msg.msg,
                    showConfirmButton: true
                });
            }
            // }
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Request failed: ' + error.message,
                showConfirmButton: true
            });
        }
    }

    window.handleSubmit = handleSubmit;
    // window.errorCallback = function (error) {
    //     console.log(JSON.stringify(error));
    // };

    // window.cancelCallback = function () {
    //     console.log('Payment cancelled');
    //     handleSubmit(0);
    // };

    // window.completeCallback = function (data) {
    //     console.log(data);
    //     handleSubmit(data);
    // };




    return <>
        <div id="wrapper" class="clearfix">

            {/* <!-- Start main-content --> */}
            <div class="main-content-area">
                {/* <!-- Section: home --> */}
                <section id="home" class="divider parallax layer-overlay overlay-dark-9" data-tm-bg-img="images/bg/bg4.jpg" style={{ backgroundImage: `url('/images/bg/bg4.jpg')` }}>
                    <div class="display-table">
                        <div class="display-table-cell">
                            <div class="container pt-100 pb-100">
                                <div class="row">
                                    <div class="col-md-6 offset-md-3">
                                        {/* <div class="text-center mb-60"><a href="#" class=""><img alt="images" src="images/logo-wide-white.png" /></a></div> */}
                                        <div class="bg-white-fc border-1px p-25">
                                            <h4 class="text-theme-colored1 text-uppercase m-0">Register Now</h4>
                                            <div class="line-bottom mb-30"></div>
                                            {/* <p>Lorem ipsum dolor sit amet, consectetur elit.</p> */}
                                            <form class="mt-30" method="post" onSubmit={registartionForCourses}>
                                                <div class="row">

                                                    <div class="col-sm-12">
                                                        <div class="mb-3 mb-10">
                                                            <input
                                                                className={`form-control required ${errors.firstName ? "is-invalid" : ""}`}
                                                                type="text"
                                                                placeholder="Enter First Name"
                                                                value={firstName}
                                                                onChange={(e) => setFirstName(e.target.value)}
                                                            />
                                                            {errors.firstName && <small className="text-danger">{errors.firstName}</small>}

                                                        </div>
                                                    </div>
                                                    <div class="col-sm-12">
                                                        <div class="mb-3 mb-10">
                                                            <input
                                                                className={`form-control required ${errors.secondName ? "is-invalid" : ""}`}
                                                                type="text"
                                                                placeholder="Enter Second Name"
                                                                value={secondName}
                                                                onChange={(e) => setSecondName(e.target.value)}
                                                            />
                                                            {errors.secondName && <small className="text-danger">{errors.secondName}</small>}
                                                        </div>
                                                    </div>
                                                    <div class="col-sm-12">
                                                        <div class="mb-3 mb-10">
                                                            <input
                                                                className={`form-control required ${errors.lastName ? "is-invalid" : ""}`}
                                                                type="text"
                                                                placeholder="Enter Last Name"
                                                                value={lastName}
                                                                onChange={(e) => setLastName(e.target.value)}
                                                            />
                                                            {errors.lastName && <small className="text-danger">{errors.lastName}</small>}
                                                        </div>
                                                    </div>
                                                    <div class="col-sm-12">
                                                        <div class="mb-3 mb-10">
                                                            <input
                                                                className={`form-control required ${errors.position ? "is-invalid" : ""}`}
                                                                type="text"
                                                                placeholder="Position"
                                                                value={position}
                                                                onChange={(e) => setPosition(e.target.value)}
                                                            />
                                                            {errors.position && <small className="text-danger">{errors.position}</small>}
                                                        </div>
                                                    </div>
                                                    <div class="col-sm-12">
                                                        <div class="mb-3 mb-10">
                                                            <div class="input-group">
                                                                <span class="input-group-text" id="basic-addon1"><i className="flaticon-contact-043-email-1 font-icon sm-display-block"></i></span>

                                                                <input
                                                                    className={`form-control required ${errors.email ? "is-invalid" : ""}`}
                                                                    type="email"
                                                                    placeholder="Enter Email"
                                                                    value={email}
                                                                    onChange={(e) => setEmail(e.target.value)}
                                                                />

                                                            </div>
                                                            {errors.email && <small className="text-danger">{errors.email}</small>}
                                                        </div>
                                                    </div>
                                                    <div class="col-sm-12">
                                                        <div class="mb-3 mb-10">
                                                            <div class="input-group">
                                                                <span class="input-group-text" id="basic-addon1"><i className="flaticon-contact-042-phone-1 font-icon"></i></span>

                                                                <input
                                                                    className={`form-control required ${errors.mobile ? "is-invalid" : ""}`}
                                                                    type="number"
                                                                    placeholder="Enter Mobile"
                                                                    value={mobile}
                                                                    onChange={(e) => setMobile(e.target.value)}
                                                                />

                                                            </div>
                                                            {errors.mobile && <small className="text-danger">{errors.mobile}</small>}
                                                        </div>
                                                    </div>
                                                    {/* <div class="col-sm-12">
                                                        <div class="mb-3 mb-10">
                                                            <select class="form-select" value={selectedCourse} onChange={(e) => setSelectedCourse(e.target.value)} aria-label="Default select example">
                                                                <option selected value={course_id} >{course_name}</option>
                                                                {courses.map((course, index) => <>
                                                                    <option key={index} value={course.id}>{course.name}</option>

                                                                </>)}
                                                            </select>
                                                        </div>
                                                    </div> */}
                                                    <div class="col-sm-12">
                                                        <div class="mb-3 mb-10">
                                                            {/* <div class="form-check">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="checkbox"
                                                                    checked={onlinePayment === 1}
                                                                    onChange={handleCheckboxChange}
                                                                />


                                                                <label class="form-check-label" for="flexCheckDefault">
                                                                    If you want to pay online you can select on online payment checkbox
                                                                </label>
                                                                {errors.onlinePayment && (
                                                                    <small className="text-danger">{errors.onlinePayment}</small>
                                                                )}
                                                            </div> */}
                                                            {amount >= 2000 && (
                                                                <div className="form-check">
                                                                    <input
                                                                        className="form-check-input"
                                                                        type="checkbox"
                                                                        checked={onlinePayment === 1}
                                                                        onChange={handleCheckboxChange}
                                                                    />

                                                                    <label className="form-check-label">
                                                                        If you want to pay online you can select online payment
                                                                    </label>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="mb-3 tm-sc-button mb-0 mt-20">
                                                    <input name="form_botcheck" class="form-control" type="hidden" value="" />
                                                    {courses?.fees < 2000 ? <button type="submit" class="btn btn-theme-colored1 btn-sm" data-loading-text="Please wait..."> proceed to Payment </button> : <button type="submit" class="btn btn-theme-colored1 btn-sm" data-loading-text="Please wait..."> Submit</button>}
                                                </div>
                                            </form>

                                        </div>
                                    </div>







                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            {/* <!-- end main-content --> */}



        </div>
        {/* <div id="payment" dangerouslySetInnerHTML={{ __html: payment }}>

        </div> */}
    </>
}
